import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React, { createContext, useState, useEffect } from 'react';
import LayoutBody from './LayoutBody.js';
export { default as LayoutBody } from './LayoutBody.js';
import LayoutFooter from './LayoutFooter.js';
export { default as LayoutFooter } from './LayoutFooter.js';
import LayoutGlobalActions from './LayoutGlobalActions.js';
export { default as LayoutGlobalActions } from './LayoutGlobalActions.js';
import LayoutHeader from './LayoutHeader.js';
export { default as LayoutHeader } from './LayoutHeader.js';
import LayoutMenuButton from './LayoutMenuButton.js';
export { default as LayoutMenuButton } from './LayoutMenuButton.js';
import LayoutNotification from './LayoutNotification.js';
export { default as LayoutNotification } from './LayoutNotification.js';
import LayoutRail from './LayoutRail.js';
export { default as LayoutRail } from './LayoutRail.js';
import LayoutSectionHeader from './LayoutSectionHeader.js';
export { default as LayoutSectionHeader } from './LayoutSectionHeader.js';
import LayoutUserInfo from './LayoutUserInfo.js';
export { default as LayoutUserInfo } from './LayoutUserInfo.js';

var _excluded = ["as", "background", "children", "className", "fullWidth", "darkMode", "theme"];
var LayoutContext = /*#__PURE__*/createContext({
  isHeaderFixed: false
});
LayoutContext.displayName = 'Layout.Context';
var Layout = function Layout(props) {
  var _classnames;
  var _props$as = props.as,
    As = _props$as === void 0 ? 'div' : _props$as,
    background = props.background,
    children = props.children,
    className = props.className,
    fullWidth = props.fullWidth,
    _props$darkMode = props.darkMode,
    darkMode = _props$darkMode === void 0 ? 'system' : _props$darkMode,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'default' : _props$theme,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDarkMode = _useState2[0],
    setIsDarkMode = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHeaderFixed = _useState4[0],
    setIsHeaderFixed = _useState4[1];
  useEffect(function () {
    if (darkMode === 'system') {
      setIsDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches);
    } else if (darkMode === 'false' || darkMode === false) {
      setIsDarkMode(false);
    } else if (darkMode === 'true' || darkMode === true) {
      setIsDarkMode(true);
    } else {
      setIsDarkMode(darkMode);
    }
  }, [darkMode]);
  var finalClasses = classnames('C-Layout', (_classnames = {
    '--fullWidth': fullWidth,
    'C-Mode--dark': isDarkMode === true,
    'C-Mode--light': isDarkMode === false
  }, _defineProperty(_classnames, "C-Theme--".concat(theme), theme), _defineProperty(_classnames, "--background--".concat(background), background), _classnames), className);
  var parentProps = {
    isHeaderFixed: isHeaderFixed,
    setIsHeaderFixed: setIsHeaderFixed
  };
  var headerBackgroundClasses = classnames('C-Layout__headerBackground', {
    '--fixed': isHeaderFixed
  });
  return /*#__PURE__*/React.createElement(LayoutContext.Provider, {
    value: parentProps
  }, /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    id: "canvasPortalContainer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "C-Layout__backgroundCover"
  }), /*#__PURE__*/React.createElement("div", {
    className: headerBackgroundClasses
  }), children));
};
Layout.displayName = 'Layout';
Layout.Body = LayoutBody;
Layout.GlobalActions = LayoutGlobalActions;
Layout.Footer = LayoutFooter;
Layout.Header = LayoutHeader;
Layout.MenuButton = LayoutMenuButton;
Layout.Notification = LayoutNotification;
Layout.Rail = LayoutRail;
Layout.SectionHeader = LayoutSectionHeader;
Layout.UserInfo = LayoutUserInfo;

export { LayoutContext, Layout as default };
